import axios from 'axios'
import { instance } from '@cognitivecredit/ui-utils'
import { getApiDomain } from '@/config'

export const getFileDownloadUrls = async (docName: string) => {
  try {
    const req = await instance({ apiDomain: getApiDomain('eng-watermark-removal') })
    const res = await req.get(`/watermark/download-url/${docName}`)
    return res.data.data
  } catch (e) {
    console.error('Error getting file download URL', e)
  }
}

export const startWatermarkProcess = async (fileName: string) => {
  try {
    const req = await instance({ apiDomain: getApiDomain('eng-watermark-removal') })
    const res = await req.post('/watermark/start', {
      document_name: fileName,
    })
    return res.data.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const uploadDoc = async (url: string, file: File) => {
  const fileData = new FormData()
  fileData.append('upload_file', file)
  try {
    const res = await axios({
      method: 'PUT',
      url: url,
      data: fileData.get('upload_file'),
      headers: { 'content-type': 'application/pdf' },
    })
    return res
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getUploadUrl = async (fileName: string) => {
  try {
    const req = await instance({ apiDomain: getApiDomain('eng-watermark-removal') })
    const { data } = await req.get(`/watermark/upload-url/${fileName}`)
    return data.data.upload_url
  } catch (e) {
    return Promise.reject(e)
  }
}

export const saveAcceptedConfig = async (processIdentifier: string | null, configName: string | undefined) => {
  if (!processIdentifier || !configName) return
  try {
    const req = await instance({ apiDomain: getApiDomain('eng-watermark-removal') })
    const res = await req.patch(`/watermark/chosen-config/${processIdentifier}`, {
      config: configName,
    })
    return res.data.data
  } catch (e) {
    return Promise.reject(e)
  }
}
